import React from "react";

import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import NoteMediaNodeView from "components/organisms/note/extensions/NoteMediaNodeView";

const NoteVideo = Node.create({
    name: "noteVideo",
    group: "block",
    atom: true,
    draggable: true,

    addAttributes() {
        return {
            assetId: { default: null },
            src: { default: null },
            provider: { default: "upload" },
            poster: { default: null },
            width: { default: null },
            align: { default: null },
        };
    },

    parseHTML() {
        return [{ tag: "video[data-note-video]" }];
    },

    renderHTML({ HTMLAttributes }) {
        const { align, style, width, ...restAttributes } = HTMLAttributes;
        const styles = [
            style,
            width ? `width: ${width}` : null,
            align === "left" ? "margin-left: 0; margin-right: auto" : null,
            align === "center" ? "margin-left: auto; margin-right: auto" : null,
            align === "right" ? "margin-left: auto; margin-right: 0" : null,
        ].filter(Boolean);

        return [
            "video",
            mergeAttributes(restAttributes, {
                "data-note-video": "true",
                ...(align ? { "data-note-align": align } : {}),
                controls: "true",
                ...(styles.length ? { style: styles.join("; ") } : {}),
            }),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer((props) => <NoteMediaNodeView {...props} type="video" />);
    },
});

export default NoteVideo;
